import { useDynamicConfigValue } from '@/hooks/use-dynamic-config-value';

export const useCatalogFilteringEnabled = () => {
  const catalogFilteringEnabled = useDynamicConfigValue(
    'catalog_filtering_enabled',
  );
  const saltApiIntegrationEnabled = useDynamicConfigValue(
    'salt_api_integration_enabled',
  );

  // Disable catalog filtering when SALT API integration is enabled since catalog filters
  // are derived from gtin_metadata, not SALT
  return Boolean(catalogFilteringEnabled && !saltApiIntegrationEnabled);
};
